import toUpper from "lodash/toUpper";

export default {
    isProdIntra: (session) => session.environmentName && (toUpper(session.environmentName) === "PRODINTRA" || toUpper(session.environmentName) === "AWSPROD")
};
